import React from "react";
import Render from "@gqlapp/theme";
import { Helmet } from 'react-helmet';
import template from "./not-found.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import { fetchMenu } from "@lib/content/fetch";

export default function PageNotFound(props: any){
	return <>
		<Helmet><title>404 - Không tìm thấy trang</title></Helmet>
		<Render {...{ template, context: { partials: { ...sharedPartials }, path: props?.path || '', categories: props?.categories || [] } }} />
	</>;
}

PageNotFound.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	try {
		if (!apolloClient) return { categories: [] };
		const categories = await fetchMenu(apolloClient, 'article');
		return { categories: categories || [] };
	} catch (e) {
		debug(e);
		return { categories: [] };
	}
};
